import { Sidebar } from "./SideBar";
import { Header } from './Header';
import { useState } from "react";
import { Content } from './Dashboard';
import { Outlet } from "react-router-dom";

const styles = `
  .admin_layout {
    display: flex !important;
    flex-direction: row !important;
    height: 100vh !important;
    width: 100% !important;
    overflow: hidden !important;
  }

  .admin_layout__body {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    height: 100vh !important;
    min-width: 0 !important;
  }

  .admin_contents {
    flex: 1 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
    height: 100% !important;
  }

  /* Fix WOW.js hiding content inside admin */
  .admin_layout .wow {
    visibility: visible !important;
    animation-name: none !important;
  }
`;

// ─── Layout ───────────────────────────────────────────────────────────────────
export function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <style>{styles}</style>
      <div className="admin_layout">
        <Sidebar collapsed={!sidebarOpen} />
        <div className="admin_layout__body">
          <Header onMenuClick={() => setSidebarOpen((p) => !p)} />
          <Content>
            <Outlet />
          </Content>
        </div>
      </div>
    </>
  );
}